var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import React from 'react';
import { Helmet } from 'react-helmet/es/Helmet';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { SubmissionError } from 'redux-form';
import { apiGetCategorySelect } from '../../../actions/CategoryActions';
import { apiCreateContactToProfessional } from '../../../actions/ContactActions';
import { apiCreateProfessionalFavorite, apiDeleteProfessionalFavorite, } from '../../../actions/FavoriteActions';
import { hideModal, MODAL_TYPE_INQUIRY_TO_CONSULTANT, MODAL_TYPE_PDF_VIEW_IMAGE, showModal, } from '../../../actions/ModalActions';
import { apiGetOneProfessional } from '../../../actions/ProfessionalActions';
import { REGISTRATION_TYPE_PROFESSIONAL_ONE } from '../../../define/consts/registration';
import { FORBIDDEN, NOT_FOUND } from '../../../define/response';
import { getFullName, isGuest } from '../../../helpers/auth';
import { emptyFunc, isNullOrUndefinedOrEmpty } from '../../../helpers/common';
import { relationFilterByNormal } from '../../../helpers/common/ProfessionalInformationHelper';
import { propArrayShape, propFunc, propMatch, propShape, propStr, PropTypesAuthToken, } from '../../../helpers/custom-prop-types';
import { getPosition } from '../../../helpers/profile';
import { createValidateErrorData } from '../../../helpers/validate';
import GoogleAnalytics from '../../../vendor/GoogleAnalytics';
import HubSpot from '../../../vendor/HubSpot';
import ForbiddenOne from '../../Forbidden/ForbiddenOne';
import MediaQueryHocForAbout from '../../FreeProfessional/Profile/MediaQueryHocForAbout';
import Layout from '../../Layout';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import { CurrentProcessLoader } from '../../Ui/Loading';
import ModalPortal from '../../Ui/Modal/ModalPortal';
import PdfImageModal from '../../Ui/Modal/Pdf/PdfImageModal';
import RegistrationAlertModal from '../../Ui/Modal/RegistrationAlertModal';
import ProfessionalInquiryModal from './Modal/ProfessionalInquiryModal';
import AboutContents from './Parts/AboutContents';
import AboutProfile from './Parts/AboutProfile';
class ProfessionalsOne extends React.Component {
    constructor(props) {
        super(props);
        this.getState = (props, state) => {
            const { experiencedIndustryClasses, largeTasks, professional } = props;
            const { information, isFavorite: firstIsFavorite } = professional || {};
            const { IsFavorite: stateIsFavorite } = state;
            const isFavorite = isNullOrUndefinedOrEmpty(stateIsFavorite)
                ? firstIsFavorite
                : stateIsFavorite;
            const rawMiddleThemes = _.get(information, 'middleTasks', []);
            const middleThemes = rawMiddleThemes.filter((v) => !!v.especially);
            const viewLargeThemes = largeTasks
                .filter(relationFilterByNormal)
                .map((largeTask) => {
                const setMiddleTasks = rawMiddleThemes.filter((v) => v.largeTaskId === largeTask.id);
                return Object.assign(Object.assign({}, largeTask), { middleTasks: setMiddleTasks });
            })
                .filter(({ middleTasks }) => middleTasks.length > 0);
            const careers = _.sortBy(_.get(information, 'careers', []), [
                'date',
            ]).reverse();
            const services = _.get(information, 'relatedSolutions') || [];
            const viewExperiencedIndustryClasses = _.get(information, 'experiencedIndustryClasses', []);
            const viewEspeciallyExperiencedIndustryClasses = viewExperiencedIndustryClasses.filter((experiencedIndustryClass) => !!experiencedIndustryClass.especially);
            return Object.assign(Object.assign({}, state), { baseSkills: _.get(information, 'baseSkills'), careers, catchphrase: _.get(information, 'catchphrase') || '', description: _.get(information, 'description'), experience: _.get(information, 'experience'), experienceList: _.get(information, 'experienceClasses'), experiencedIndustryClasses: experiencedIndustryClasses.filter(relationFilterByNormal), file: _.get(information, 'file') || '', isFavorite: !!isFavorite, name: getFullName(professional), organizationFeatures: (_.get(professional, 'organization.feature') || '')
                    .split('\n')
                    .map((v) => v.trim())
                    .filter((v) => v)
                    .map((value, id) => ({ id, value })), organizationName: _.get(professional, 'organization.name') || '', personalities: _.get(information, 'personalities'), positionName: getPosition(professional, false), professional, projects: _.get(information, 'projectCareers'), relatedDocuments: _.get(information, 'relatedDocuments'), relatedLinks: _.get(information, 'relatedLinks'), services, themes: middleThemes, unit: _.get(professional, 'unit'), viewEspeciallyExperiencedIndustryClasses,
                viewExperiencedIndustryClasses,
                viewLargeThemes });
        };
        this.getContactForProfessionalQuestionTypesState = (props) => {
            const { contactForProfessionalQuestionTypes } = props;
            return {
                contactForProfessionalQuestionTypes: contactForProfessionalQuestionTypes.map((v) => ({
                    label: v.name,
                    value: v.id,
                })),
            };
        };
        this.loadData = (props) => {
            const { loadConsultant, match } = props;
            this.setState({ isForbidden: false });
            loadConsultant(match.params.id, () => {
                if (!this.unmount) {
                    this.setState({ isForbidden: true });
                }
            });
        };
        this.getMetaDescription = () => {
            const { experience, organizationFeatures, viewExperiencedIndustryClasses, viewLargeThemes, } = this.state;
            // 全て未登録の場合デフォルト文言
            if (!experience &&
                !viewExperiencedIndustryClasses.length &&
                !viewLargeThemes.length &&
                !organizationFeatures.length) {
                return 'PROFFITはコンサル選定支援サービスです。登録されているコンサルタントに対し、予算水準や、過去の経験・実績について質問することが出来ます。';
            }
            // コンサルタント歴
            const descriptionOfExperienceText = experience
                ? `コンサルタント歴${experience}年`
                : '';
            // 特に得意な業界
            const descriptionOfIndustryClasses = viewExperiencedIndustryClasses.length
                ? `特に得意な業界 ${viewExperiencedIndustryClasses
                    .map(({ name }) => name)
                    .join('、')}`
                : '';
            // 特に得意なテーマ
            const descriptionOfTheme = viewLargeThemes.length
                ? `特に得意なテーマ ${viewLargeThemes.map(({ name }) => name).join('、')}`
                : '';
            // 会社の特長
            const descriptionOfOrganizationFeatures = organizationFeatures.length
                ? `会社の特長 ${organizationFeatures
                    .map(({ value }, i) => `${i + 1}.${value}`)
                    .join(' ')}`
                : '';
            return [
                descriptionOfExperienceText,
                descriptionOfIndustryClasses,
                descriptionOfTheme,
                descriptionOfOrganizationFeatures,
            ]
                .filter((text) => !!text)
                .join(' ');
        };
        this.onInquirySubmit = (values) => __awaiter(this, void 0, void 0, function* () {
            const { match, sendInquiry } = this.props;
            const { contact_type: contactType, content, question_type_id: { value: questionTypeId }, } = values;
            try {
                yield sendInquiry({
                    contactType: contactType ? 1 : 2,
                    content,
                    questionTypeId: questionTypeId.toString(),
                }, match.params.id);
                if (!this.unmount) {
                    this.setState({ tabViewIsComplete: true });
                }
            }
            catch (e) {
                throw new SubmissionError(createValidateErrorData(e));
            }
        });
        this.onClickInquiryHide = () => {
            const { hideInquiryModal } = this.props;
            hideInquiryModal();
        };
        this.onClickShowInquiry = () => {
            const { match: { params: { id }, }, showInquiryModal, } = this.props;
            this.setState({ tabViewIsComplete: false });
            GoogleAnalytics.sendClickEvent('contact_consultant', 'contact_consultant_count', '');
            HubSpot.trackPageView(`/consultant/${id}/inquiry`);
            showInquiryModal();
        };
        this.onClickFavorite = () => __awaiter(this, void 0, void 0, function* () {
            const { createFavorite, deleteFavorite, match } = this.props;
            const { isFavorite } = this.state;
            try {
                if (!this.unmount) {
                    this.setState({ isFavoriteDoing: true });
                }
                if (isFavorite) {
                    yield deleteFavorite(match.params.id);
                }
                else {
                    yield createFavorite(match.params.id);
                }
                if (!this.unmount) {
                    this.setState({ isFavorite: !isFavorite });
                }
            }
            finally {
                if (!this.unmount) {
                    this.setState({ isFavoriteDoing: false });
                }
            }
        });
        const defaultState = {
            isFavoriteDoing: false,
            isForbidden: false,
            tabViewIsComplete: false,
        };
        this.state = Object.assign(Object.assign({}, this.getState(this.props, defaultState)), this.getContactForProfessionalQuestionTypesState(this.props));
        this.unmount = false;
        this.formInitialValues = {
            contact_type: false,
        };
    }
    componentDidMount() {
        const { loadCategory } = this.props;
        loadCategory();
        this.loadData(this.props);
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { contactForProfessionalQuestionTypes, experiencedIndustryClasses, largeTasks, loadConsultant, match: { params: { id }, }, professional, } = this.props;
        if (id !== nextProps.match.params.id ||
            loadConsultant !== nextProps.loadConsultant) {
            this.loadData(nextProps);
        }
        let result = true;
        if (professional !== nextProps.professional ||
            largeTasks !== nextProps.largeTasks ||
            experiencedIndustryClasses !== nextProps.experiencedIndustryClasses) {
            this.setState(this.getState(nextProps, nextState));
            result = false;
        }
        if (contactForProfessionalQuestionTypes !==
            nextProps.contactForProfessionalQuestionTypes) {
            this.setState(this.getContactForProfessionalQuestionTypesState(nextProps));
            result = false;
        }
        return result;
    }
    componentWillUnmount() {
        this.unmount = true;
    }
    render() {
        const { auth, profile, showPdfModal, size } = this.props;
        const { baseSkills, careers, contactForProfessionalQuestionTypes, description, experience, experienceList, experiencedIndustryClasses, file, isFavorite, isFavoriteDoing, isForbidden, name, organizationFeatures, organizationName, positionName, professional, projects, relatedDocuments, relatedLinks, services, tabViewIsComplete, themes, unit, viewEspeciallyExperiencedIndustryClasses, viewExperiencedIndustryClasses, viewLargeThemes, } = this.state;
        if (isForbidden) {
            return (_jsx(ForbiddenOne, { text: '他社のコンサルタントの方の情報はノウハウを保護するため、開示できません。' }));
        }
        const metaDescription = this.getMetaDescription();
        const isGuestMember = isGuest(auth);
        const isShow = !isGuestMember;
        const { metaInformation } = professional || {};
        return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main layout_consultant_one bg-about is-consultant' }, { children: [professional ? (_jsxs("div", Object.assign({ className: 'l-about is-view' }, { children: [_jsxs(Helmet, { children: [_jsx("meta", { content: metaDescription, name: 'description' }), metaInformation && metaInformation.robots && (_jsx("meta", { content: metaInformation.robots, name: 'robots' }))] }), _jsx(AboutProfile, { baseSkills: baseSkills, experience: experience, experienceList: experienceList, file: file, isBlur: !isShow, isFavorite: isFavorite, isFavoriteDoing: isFavoriteDoing, name: name, onClickFavorite: this.onClickFavorite, onClickInquiry: this.onClickShowInquiry, organizationName: organizationName, positionName: positionName, unit: unit }), _jsx(AboutContents, { careers: careers, description: description, experiencedIndustryClasses: experiencedIndustryClasses, isBlur: !isShow, organizationFeatures: organizationFeatures, projects: projects, relatedDocuments: relatedDocuments, relatedLinks: relatedLinks, services: services, showPdfModal: showPdfModal, size: size, themes: themes, unit: unit, viewEspeciallyExperiencedIndustryClasses: viewEspeciallyExperiencedIndustryClasses, viewExperiencedIndustryClasses: viewExperiencedIndustryClasses, viewLargeThemes: viewLargeThemes })] }))) : (_jsx(CurrentProcessLoader, { marginTop: 30 })), _jsxs(ModalPortal, Object.assign({ selector: '#app' }, { children: [isShow && (_jsxs(_Fragment, { children: [_jsx(PdfImageModal, {}), _jsx(ProfessionalInquiryModal, { contactForProfessionalQuestionTypes: contactForProfessionalQuestionTypes, initialValues: this.formInitialValues, onClickHide: this.onClickInquiryHide, onSubmit: this.onInquirySubmit, profile: profile, tabViewIsComplete: tabViewIsComplete })] })), professional && (_jsx(RegistrationAlertModal, { isShow: isGuestMember, onClickOther: emptyFunc, onSubmitEvent: this.onSubmitEvent, registrationType: REGISTRATION_TYPE_PROFESSIONAL_ONE }))] }))] })));
    }
}
ProfessionalsOne.propTypes = {
    auth: PropTypesAuthToken.isRequired,
    contactForProfessionalQuestionTypes: propArrayShape(),
    createFavorite: propFunc().isRequired,
    deleteFavorite: propFunc().isRequired,
    experiencedIndustryClasses: propArrayShape(),
    hideInquiryModal: propFunc().isRequired,
    largeTasks: propArrayShape(),
    loadCategory: propFunc().isRequired,
    loadConsultant: propFunc().isRequired,
    match: propMatch(),
    professional: propShape(),
    profile: propShape(),
    sendInquiry: propFunc().isRequired,
    showInquiryModal: propFunc().isRequired,
    showPdfModal: propFunc().isRequired,
    size: propStr().isRequired,
};
ProfessionalsOne.defaultProps = {
    contactForProfessionalQuestionTypes: [],
    experiencedIndustryClasses: [],
    largeTasks: [],
    professional: null,
    profile: {},
};
const mapStateToProps = (state, props) => {
    const { auth, category, professional, profile } = state;
    const { match } = props;
    return {
        auth,
        contactForProfessionalQuestionTypes: category.contactForProfessionalQuestionTypes,
        experiencedIndustryClasses: category.experiencedIndustryClasses,
        largeTasks: category.largeTasks,
        professional: professional[match.params.id],
        profile,
    };
};
const mapDispatchToProps = (dispatch, { history }) => ({
    createFavorite: (id) => new Promise((resolve, reject) => {
        dispatch(apiCreateProfessionalFavorite(id, {
            reject,
            resolve,
        }));
    }),
    deleteFavorite: (id) => new Promise((resolve, reject) => {
        dispatch(apiDeleteProfessionalFavorite(id, {
            reject,
            resolve,
        }));
    }),
    hideInquiryModal: () => dispatch(hideModal(MODAL_TYPE_INQUIRY_TO_CONSULTANT)),
    loadCategory: () => {
        dispatch(apiGetCategorySelect('contact_for_professional_question_type'));
    },
    loadConsultant: (id, forbiddenCallback) => dispatch(apiGetOneProfessional(id, {
        id,
        reject: {
            [FORBIDDEN]: forbiddenCallback,
            [NOT_FOUND]: () => history.push('/'),
        },
    })),
    sendInquiry: (value, id) => new Promise((resolve, reject) => {
        dispatch(apiCreateContactToProfessional(value, id, {
            reject,
            resolve,
        }));
    }),
    showInquiryModal: () => dispatch(showModal(MODAL_TYPE_INQUIRY_TO_CONSULTANT)),
    showPdfModal: (images) => dispatch(showModal(MODAL_TYPE_PDF_VIEW_IMAGE, null, { images })),
});
const enhance = compose(AuthenticationHoc({
    isPreClient: false,
    notPreClientRedirectTo: '/mypage',
}), connect(mapStateToProps, mapDispatchToProps), MediaQueryHocForAbout);
export default enhance(ProfessionalsOne);
